import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import FaqSchema from './schema';
import FaqBody from './FaqBody';
import type { FaqData } from './FaqBody';

type FaqEditProps = {
  data: FaqData;
  block: string;
  selected: boolean;
  onChangeBlock: (block: string, data: FaqData) => void;
};

const FaqEdit = (props: FaqEditProps) => {
  const { data, block, onChangeBlock, selected } = props;
  const intl = useIntl();
  const schema = FaqSchema({ intl });

  return (
    <>
      <FaqBody data={data} isEditMode />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id: string, value: unknown) => {
            onChangeBlock(block, { ...data, [id]: value });
          }}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default FaqEdit;
